import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const ContactInfoSidebar = () => {
  return (
    <Box sx={{ my: 4, p: 1 }}>
        <Typography variant="h5" gutterBottom component="div" sx={{ textAlign: 'center'}}>
          Other Contact Information
        </Typography>
      <Typography variant="subtitle1" gutterBottom>
        MAILING ADDRESS
      </Typography>
      <Typography variant="body2" gutterBottom>
        BEADS for Education, Inc. <br />
        Debby Rooney <br />
        BEADS for Education Founder and CEO <br />
        P.O BOX 784 <br />
        Brookfield, CT 06804
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        TELEPHONE
      </Typography>
      <Typography variant="body2" gutterBottom>
        Debby Rooney, BEADS Co-founder <br />
        609-992 7891
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        EMAIL
      </Typography>
      <Typography variant="body2" gutterBottom>
        General Information <br />
        Debby Rooney <br />
        <Link href="mailto:BEADSofKenya@aol.com" >BEADSofKenya@aol.com</Link>
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        FACEBOOK
      </Typography>
      <Typography variant="body2" gutterBottom>
        Like our BEADS for Education page on 
        <Link href="https://web.facebook.com/beadsforeducation" target="_blank" rel="noopener noreferrer"> Facebook </Link> 
        and follow our updates, pictures, and videos.
      </Typography>
    </Box>
  );
};

export default ContactInfoSidebar;
